module.exports = __webpack_public_path__ + "static/media/18.55221bbb.jpg";